import {
  createFileRoute,
  linkOptions,
  redirect,
  Outlet,
} from '@tanstack/react-router';

const scoutRequestLinkOptions = linkOptions({
  to: '/mydigitalworkers/scout/requests',
  from: '/mydigitalworkers/scout/reports',
});

export const Route = createFileRoute(
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/',
)({
  beforeLoad: () => {
    throw redirect(scoutRequestLinkOptions);
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
